"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidURL = exports.STYLE = exports.hasLink = exports.hasBlockType = exports.hasInlineStyle = exports.findLinkEntities = exports.getBlockStyle = exports.getHTMLString = void 0;
const draft_js_1 = require("draft-js");
const draft_js_export_html_1 = require("draft-js-export-html");
/**
 * This function allows us to get the html.
 * e.g: in FormReader, we can then display the enriched comment
 * created in FormWriter (formData).
 * We use stateToHTML, instead of draftToHtml so we keep
 * the attribute target and open links in a new tab.
 * We'll also keep our <br> tags.
 */
const getHTMLString = editorState => {
    const contentState = editorState.getCurrentContent();
    const options = {
        entityStyleFn: entity => {
            const data = entity.getData();
            let config;
            if (entity.get('type') === 'LINK')
                config = {
                    element: 'a',
                    attributes: {
                        href: data.url,
                        target: data.target
                    }
                };
            return config;
        }
    };
    // Get the html generated by the user.
    const html = draft_js_export_html_1.stateToHTML(contentState, options);
    // Remove all spaces from our content test. Spaces are html encoded. The content
    // test regex is easier without spaces.
    const testHtml = html.replace(/&nbsp;/gm, '');
    // If there is any content between html tags or any image tags we should
    // return the html generated by the user. If not we should return undefined
    // because the user has only generated white space or formatting.
    return /(>[^<>\n]+<|<img)/gm.exec(testHtml) ? html : undefined;
};
exports.getHTMLString = getHTMLString;
/**
 * This allows us to rename the class
 * This function is passed inside the prop blockStyleFn (belongs to draft-js Editor component)
 */
const getBlockStyle = block => {
    switch (block.getType()) {
        case 'header-one': // looking for an element with the type of
            return `h1`; // name a style class for this element
        case 'unordered-list-item':
            return `ul`;
        default:
            return '';
    }
};
exports.getBlockStyle = getBlockStyle;
/**
 * This Function is used in connection with the decorator
 * passed to the new editorState object (./richEditor).
 * This enables us to use our own Link component (./controlPanel/link)
 */
const findLinkEntities = (contentBlock, callback) => {
    contentBlock.findEntityRanges(character => {
        const entityKey = character.getEntity();
        return entityKey !== null && draft_js_1.Entity.get(entityKey).getType() === 'LINK';
    }, callback);
};
exports.findLinkEntities = findLinkEntities;
/**
 * This allows us to know which inline style is active
 * to toggle the corresponding button (e.g bold).
 */
const hasInlineStyle = (editorState, style) => {
    // currentStyle is a map of currently applied style to selected text
    const currentStyle = editorState.getCurrentInlineStyle();
    // check if current style is among the style map.
    return currentStyle.has(style);
};
exports.hasInlineStyle = hasInlineStyle;
/**
 * This allows us to know which blocktype is active
 * to toggle the corresponding button (e.g h1).
 */
const hasBlockType = (editorState, type) => {
    const selection = editorState.getSelection();
    return (editorState
        .getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType() === type);
};
exports.hasBlockType = hasBlockType;
/**
 * This allows us to know if the block selection has a link
 */
const hasLink = editorState => draft_js_1.RichUtils.currentBlockContainsLink(editorState);
exports.hasLink = hasLink;
/**
 * An array to map the style when applying onClick on a controlPanel button
 * The LINK button is handled separately
 */
exports.STYLE = ['header-one', 'unordered-list-item', 'BOLD'];
const isValidURL = str => {
    const pattern = new RegExp('^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$', 'i');
    return !!pattern.test(str);
};
exports.isValidURL = isValidURL;
//# sourceMappingURL=editor.js.map